import { render, staticRenderFns } from "./rightDetailModal.vue?vue&type=template&id=45bb963a"
import script from "./rightDetailModal.vue?vue&type=script&lang=js"
export * from "./rightDetailModal.vue?vue&type=script&lang=js"
import style0 from "./rightDetailModal.vue?vue&type=style&index=0&id=45bb963a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports